"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsActionPanel = void 0;
var products_action_panel_component_1 = require("./products-action-panel.component");
Object.defineProperty(exports, "ProductsActionPanel", { enumerable: true, get: function () { return products_action_panel_component_1.ProductsActionPanel; } });
